import React, {useEffect, useState} from 'react';
import './ReserveBox.css';
import Menu from "../../Components/Menu/Menu";
import GameEquipment from "./GameEquipment/GameEquipment";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import QrReader from "react-qr-reader";

const ReserveBox = () => {

    const navigate = useNavigate();
    const [canOpen, setCanOpen] = useState(false); // поменять
    const [boxQrNum, setBoxQrNum] = useState(null);
    const [infoGot, setInfoGot] = useState(false);
    const [inventoryAllowed, setInventoryAllowed] = useState(false);

    useEffect(() => {
        axios.get(`/api/give_inventory/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                // 'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                if (res.data.detail.length !== 0) {
                    setInventoryAllowed(true);
                }
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
            })
    }, [setInventoryAllowed]);

    useEffect(() => {
        axios.get(`/api/currentday/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                // 'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                if (res.data.detail) {
                    setCanOpen(true);
                }
                setInfoGot(true);
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
            })
    }, [setCanOpen]);

    const toGameEquipment = () => {
        navigate('/box_reserve/game_equipment');
    }

    const toUserEquipment = () => {
        navigate('/box_reserve/user_equipment');
    }

    const handleScan = (data) => {
        if (!!data) {
            let localUrl;
            try {
                const url = new URL(data);
                localUrl = url.pathname + url.search + url.hash;
            } catch (e) {
                localUrl = '';
            }
            navigate(localUrl);
        }
    };

    const handleError = (err) => {
        if (!!err) {
            console.log(err);
        }
    };

    return (
        <div className={'box-page-container'}>
            <Menu/>
            <div className={'box-page-title'}>Система хранения:</div>
            <div className={`box-page-button ${canOpen && inventoryAllowed ? '' : 'box-page-button-closed'}`} onClick={() => toGameEquipment()}>Инвентарь</div>
            <div className={`box-page-button ${canOpen ? '' : 'box-page-button-closed'}`} onClick={() => toUserEquipment()}>Мой шкаф</div>
            {canOpen ? (
                <div className={'box-page-qr-container'}>
                    <div className={'box-page-qr'}>
                        <QrReader
                            delay={300}
                            onError={handleError}
                            onScan={handleScan}
                            facingMode={'environment'}
                            showViewFinder={false}

                            // onResult={(result, error) => {
                            //     if (!!result) {
                            //         handleScan(result);
                            //         console.log('Result: ', result);
                            //     }
                            //
                            //     if (!!error) {
                            //         console.log(error);
                            //     }
                            // }}

                            style={{width: '100%', height: '100%'}}
                            // constraints={{ facingMode: 'environment' }}
                        />
                    </div>
                </div>
            ) : ( infoGot && (
                    <div className={'box-page-closed-container'}>
                        <p className={'box-page-closed-container-text'}>Железные шкафчики доступны с 6 утра до 12 вечера</p>
                    </div>
                )
            )}
        </div>
    );
};

export default ReserveBox;